import { CurrencyFormateText } from "@/components/CurrencyFormat";

type PackageCurrencyAmountProps = {
  value?: string | number | null;
  cadValue?: string | number | null;
  showCadAmount?: boolean;
  suffix?: string;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
};

const PackageCurrencyAmount = ({
  value,
  cadValue,
  showCadAmount = false,
  suffix = "",
  decimalScale = 2,
  fixedDecimalScale = true,
}: PackageCurrencyAmountProps) => {
  if (!showCadAmount) {
    return (
      <CurrencyFormateText
        value={value}
        suffix={suffix}
        decimalScale={decimalScale}
        fixedDecimalScale={fixedDecimalScale}
      />
    );
  }

  return (
    <span className="currency">
      <CurrencyFormateText
        value={value}
        decimalScale={decimalScale}
        fixedDecimalScale={fixedDecimalScale}
        renderText={(price) => price}
      />{" "}
      (
      <CurrencyFormateText
        value={cadValue}
        prefix="CAD $"
        decimalScale={decimalScale}
        fixedDecimalScale={fixedDecimalScale}
        renderText={(price) => price}
      />
      ){suffix}
    </span>
  );
};

export default PackageCurrencyAmount;
